import React from 'react';
import paper from '../ReportPaper.module.css';
import styles from './textBodies.module.css';

/**
 * Miolo do PDF de queixas principais: as queixas vigentes do paciente como
 * etiquetas e, abaixo, a primeira avaliação registrada (mesmo conteúdo do card).
 *
 * `complaints`: lista de textos; `assessment`: texto da primeira avaliação (ou '').
 */
export const ComplaintsReportBody = ({ complaints, assessment }) => {
  const list = Array.isArray(complaints) ? complaints.filter(Boolean) : [];

  return (
    <>
      <div className={paper.section}>
        <span className={paper.sectionTitle}>Queixas vigentes</span>
        {list.length > 0 ? (
          <div className={styles.chips}>
            {list.map((item, index) => <span key={index} className={styles.chip}>{item}</span>)}
          </div>
        ) : (
          <span className={styles.muted}>Nenhuma queixa registrada.</span>
        )}
      </div>

      {assessment && (
        <div className={paper.noteBox}>
          <span className={paper.sectionTitle}>Primeira avaliação</span>
          <div className={paper.noteText}>{assessment}</div>
        </div>
      )}
    </>
  );
};

export default ComplaintsReportBody;
